import { Form } from "react-bootstrap"
import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m3 from "assets/images/users/3.jpg";
import m4 from "assets/images/users/4.jpg";
import m5 from "assets/images/users/5.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m8 from "assets/images/users/8.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm2 from "assets/images/users/02.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm5 from "assets/images/users/05.jpg";
import fm6 from "assets/images/users/06.jpg";
import fm7 from "assets/images/users/07.jpg";
import fm8 from "assets/images/users/08.jpg";
import fm9 from "assets/images/users/09.jpg";

export const MESSAGES = [
    {
        "userName": "@charlie.roman",
        "id": "13455",
        "email": "charlie.roman@ey.com",
        "fullName": "Charlie Roman",
        "lastChatTime": "Just now",
        "picture": m1,
        "status": "Available",
        "isUnread": true,
        "lastMessage": "Looks good!",
        "messages": [
            {
                "fullName": "Charlie Roman",
                "userName": "@charlie.roman",
                "email": "charlie.roman@ey.com",
                "picture": m1,
                "time": "2 mins ago",
                "messages": "Hi"
            }
        ]
    },
    {
        "id": "67455",
        "userName": "@lana",
        "fullName": "Lana Steiner",
        "email": "lana.steiner@ey.gds.ey.com",
        "lastChatTime": "2 mins ago",
        "picture": fm1,
        "status": "Busy",
        "isUnread": true,
        "lastMessage": "Thanks so much, happy with that.",
        "messages": [
            {
                "fullName": "Lana Steiner",
                "userName": "@lana",
                "email": "lana.steiner@ey.gds.ey.com",
                "picture": fm1,
                "messages": "hello"
            }
        ]
    },
    {
        "id": "19035",
        "userName": "@demi",
        "fullName": "Demi Wikinson",
        "email": "demi.wikinson@ey.gds.ey.com",
        "lastChatTime": "2 mins ago",
        "picture": m7,
        "status": "Available",
        "isUnread": false,
        "lastMessage": "Got you a coffee",
        "messages": [
        {
                "userName": "@demi",
                "fullName": "Demi Wikinson",
                "email": "demi.wikinson@ey.gds.ey.com",
                "picture": m7,

            "time": "2 mins ago",
            "messages": "Hi, "
        },
        {
                "userName": "@demi",
                "fullName": "Demi Wikinson",
                "email": "demi.wikinson@ey.gds.ey.com",
                "picture": m7,

            "time": "2 mins ago",
            "messages": "Got you a coffee"
        }
        ]
    },
    {
        "id": "9655",
        "userName": "@candice",
        "fullName": "Candice Wu",
        "email": "candice.wu@ey.gds.ey.com",
        "picture": m2,
        "lastChatTime": "3 hours ago",
        "status": null,
        "isUnread": false,
        "lastMessage": "Great to see you again!",
        "messages": [
            {
                "userName": "@candice",
                "fullName": "Candice Wu",
                "email": "candice.wu@ey.gds.ey.com",
                "picture": m2,

                "time": "2 mins ago",
                "messages": "Hi,"
            },
            {
                "userName": "@candice",
                "fullName": "Candice Wu",
                "email": "candice.wu@ey.gds.ey.com",
                "picture": m2,

                "time": "2 mins ago",
                "messages": "Great to see you again!"
            }
        ]
    },
    {
        "id": "1295",
        "userName": "@alex",
        "fullName": "Alex Craig",
        "email": "alex.craig@ey.gds.ey.com",
        "picture": m3,
        "lastChatTime": "6 hours ago",
        "status": null,
        "isUnread": false,
        "lastMessage": "We should ask Oli about this...",
        "messages": [
            {
                "userName": "@alex",
                "fullName": "Alex Craig",
                "email": "alex.craig@ey.gds.ey.com",
                "picture": m3,

                "time": "2 mins ago",
                "messages": "We should ask Oli about this..."
            }
        ]
    },
    {
        "id": "76885",
        "userName": "@drew",
        "fullName": "Drew Cano",
        "email": "drew.cano@ey.gds.ey.com",
        "lastChatTime": "12 hours ago",
        "picture": m4,
        "status": null,
        "isUnread": false,
        "lastMessage": "Okay, see you then.",
        "messages": [
            {
                "userName": "@drew",
                "fullName": "Drew Cano",
                "email": "drew.cano@ey.gds.ey.com",
                "picture": m4,
                "time": "7 hours ago",
                "messages": "Hi, How are you?"
            }
        ]
    },
    {
        "id": "442455",
        "userName": "@orlando",
        "fullName": "Orlando Diggs",
        "email": "orlando.diggs@ey.gds.ey.com",
        "picture": fm5,
        "lastChatTime": "3:42pm 20 Jan 2022",
        "status": null,
        "isUnread": false,
        "lastMessage": "We should ask Oli about this...",
        "messages": [
            {
                "userName": "@orlando",
                "fullName": "Orlando Diggs",
                "email": "orlando.diggs@ey.gds.ey.com",
                "picture": fm5,

                "time": "2 mins ago",
                "messages": "We should ask Oli about this..."
            }
        ]
    },
    {
        "id": "80075",
        "userName": "@kate",
        "fullName": "Kate Morrison",
        "email": "ketw.morrison@ey.gds.ey.com",
        "picture": fm6,
        "lastChatTime": "2:12pm 20 Jan 2022",
        "status": null,
        "isUnread": false,
        "lastMessage": "That sounds like a good plan!",
        "messages": [
            {
                "userName": "@kate",
                "fullName": "Kate Morrison",
                "email": "ketw.morrison@ey.gds.ey.com",
                "picture": fm6,

                "time": "2 mins ago",
                "messages": "That sounds like a good plan!"
            }
        ]
    },
    {
        "id": "94755",
        "userName": "@andi",
        "fullName": "Andi Lee",
        "email": "andi.lee@ey.gds.ey.com",
        "lastChatTime": "3:42pm 20 Jan 2022",
        "picture": m9,
        "status": null,
        "isUnread": false,
        "lastMessage": "I will be here soon",
        "messages": [
            {
                "fullName": "Andi Lee",
                "userName": "@andi",
                "email": "andi.lee@ey.gds.ey.com",
                "picture": m9,
                "time": "2 mins ago",
                "messages": "Hi"
            },
            {
                "fullName": "Andi Lee",
                "userName": "@andi",
                "email": "andi.lee@ey.gds.ey.com",
                "picture": m9,
                "time": "2 mins ago",
                "messages": "I will be here soon"
            },
            
        ]
    }
]